var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insights-V0",
    transform: "translate(-270.000000, -24.000000)",
    fill: "#0E103D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-filter",
    transform: "translate(270.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.66666667,
    y: 5.33333333,
    width: 6.66666667,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.66666667,
    y: 2.66666667,
    width: 8,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.66666667,
    y: 10.6666667,
    width: 4,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.666666667,
    cy: 6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.666666667,
    cy: 11.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.66666667,
    y: 8,
    width: 5.33333333,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.666666667,
    cy: 8.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.666666667,
    cy: 3.33333333,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.66666667,
    y: 0,
    width: 9.33333333,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.666666667,
    cy: 0.666666667,
    r: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.0476bed6cad39f4043942a2837817059.svg";
export { ForwardRef as ReactComponent };